import { OpenQuestionPin } from '@lessonup/pins-shared';
import { last, isEmpty, isNil, some } from 'lodash';
import { parseStringWithOptions } from '../../../utils';

// Answer
export namespace OpenQuestion {
  export interface Answer {
    modifiedAt: number; // timestamp
    texts?: string[];
  }

  export type CorrectAnswer = string[];

  export interface AnswerResult {
    type: 'correct' | 'incorrect' | 'noAnswer';
  }

  export namespace Answer {
    export const maxLength = 5000;

    export function texts(answer: Answer | undefined): string[] {
      return (answer && answer.texts) || [];
    }

    export function isCorrectAnswer(answer: any): boolean {
      return !!Array.isArray(answer) && !answer.find((a) => typeof a !== 'string');
    }

    export function numberOfAnswers(answer: Answer | undefined): number {
      return (answer && answer.texts && answer.texts.length) || 0;
    }

    export function latestText(answer: Answer | undefined): string | undefined {
      return last(answer && answer.texts);
    }

    export function update(current: Answer, fields: Partial<Answer>): Answer {
      return Object.assign({}, current, fields);
    }

    export function create(fields: Partial<Answer>): Answer {
      return Object.assign({ modifiedAt: Date.now() }, fields);
    }

    export function isDone(answer: Answer | undefined): boolean {
      return !isEmpty(answer?.texts);
    }

    export function isStringCorrect(
      text: string,
      correctAnswer: CorrectAnswer,
      settings: OpenQuestionPin['settings']
    ): boolean {
      const options = { asLowercase: !settings.caseSensitive, normalizeDiacritics: !settings.diacriticSensitive };
      return some(
        correctAnswer,
        (answer) => parseStringWithOptions(text, options) === parseStringWithOptions(answer, options)
      );
    }

    export function resultForAnswer(
      current: Answer | undefined,
      pin: OpenQuestionPin,
      correctAnswer: CorrectAnswer
    ): AnswerResult {
      const latest = latestText(current);
      if (!current || !current.texts || isNil(latest) || isEmpty(latest)) {
        return { type: 'noAnswer' };
      }
      return {
        type: isStringCorrect(latest, correctAnswer, pin.settings) ? 'correct' : 'incorrect',
      };
    }
  }
}
